import { createAction, props } from "@ngrx/store";
import { GenericApiData } from "src/components/shared-components/class/general-classes/generic-api-data";
import { AreaStoreAction } from "src/components/shared-components/enum/enumStoreAction";

/**
 * Reseet areas state and unset key storage
 */
export const areaUnsetKeyStorage = createAction(
  AreaStoreAction.AREA_UNSET_KEY_STORAGE
);

/**
 * Action fired when request to load start
 */
export const areaLoadInitStartAction = createAction(
  AreaStoreAction.AREA_LOAD_INIT_START
);

/**
 * Action to load full list of areas
 */
export const areaLoadListFromApiAction = createAction(
  AreaStoreAction.AREA_LOAD_FROM_API
);

/**
 * Action to load last modified list of areas
 */
export const areaLoadLastModifiedFromApiAction = createAction(
  AreaStoreAction.AREA_LOAD_LAST_MODIFIED_FROM_API,
  props<{ areaObject: GenericApiData }>()
);

/**
 * Action area load success
 */
export const areaLoadSuccessAction = createAction(
  AreaStoreAction.AREA_LOAD_SUCCESS,
  props<{ areaObject: GenericApiData }>()
);

/**
 * Action area load error
 */
export const areaLoadErrorAction = createAction(
  AreaStoreAction.AREA_LOAD_ERROR
);
